'use client';

import { usePathname } from 'next/navigation';

export function usePathUtils() {
  const pathname = usePathname();

  // Utilities for easy readability
  const isPath = (route: string) => pathname?.startsWith(route);
  const isNotPath = (route: string) => !pathname?.startsWith(route);
  const isExactPath = (route: string) => pathname === route;
  const isNotExactPath = (route: string) => pathname !== route;

  return { isPath, isNotPath, isExactPath, isNotExactPath };
}
